import { domScriptInjectAsync } from "@smp/utils";
import { YooMoneyCheckoutWidget } from "custom";
import { useState } from "react";
import { useEffectOnce } from "react-use";

export const useYakassa = ({
  confirmation_token,
  error_callback,
  return_url,
}: {
  confirmation_token: string;
  error_callback: (error: unknown) => void;
  return_url: string | undefined;
}) => {
  const [widget, setWidget] = useState<InstanceType<YooMoneyCheckoutWidget>>();
  const [error, setError] = useState<Error | undefined>(undefined);
  const [isRendered, setIsRendered] = useState(false);

  const destroy = () => {
    if (!widget) {
      return;
    } else {
      widget.destroy();
    }
  };

  const on = (
    ...params: Parameters<InstanceType<YooMoneyCheckoutWidget>["on"]>
  ) => {
    if (!widget) {
      return;
    } else {
      widget.on(...params);
    }
  };

  const render = (
    ...params: Parameters<InstanceType<YooMoneyCheckoutWidget>["render"]>
  ) => {
    if (!widget || isRendered) {
      return;
    } else {
      setIsRendered(true);
      widget.render(...params);
    }
  };

  useEffectOnce(() => {
    (async () => {
      try {
        if (!window.YooMoneyCheckoutWidget) {
          await domScriptInjectAsync(
            "https://yookassa.ru/checkout-widget/v1/checkout-widget.js",
          );
        }
        if (window.YooMoneyCheckoutWidget) {
          setWidget(
            new window.YooMoneyCheckoutWidget({
              confirmation_token,
              error_callback,
              return_url,
            }),
          );
        }
      } catch (clause) {
        const error = clause as Error;
        setError(error);
      }
    })();
  });

  return {
    destroy,
    error,
    isLoaded: !!widget,
    on,
    render,
  };
};
